// Copyright 2026. WebPros International GmbH. All rights reserved.

import * as React from 'react';

export const NoLayout: React.FC<React.PropsWithChildren> = ({ children }) => (
    <>
        {children}
    </>
);
